import React, { useState, } from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import NcDmvDrivingRecordDetails from './NcDmvDrivingRecordDetails';

const NcDmvDrivingRecordModal = ({ selectedDrivingRecord, }) => {
  const [ show, setShow, ] = useState(false);

  return (
    <>
      <Button variant="primary" onClick={() => setShow(true)}>
        Details
      </Button>
      <Modal show={show} onHide={() => setShow(false)} size="xl">
        <Modal.Header closeButton>
          <Modal.Title>
            Driver&apos;s License Number: {selectedDrivingRecord.driversLicenseNumber}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {(() => {
            return show
              ? <NcDmvDrivingRecordDetails selectedDrivingRecord={selectedDrivingRecord} />
              : undefined;
          })()}
        </Modal.Body>
        <Modal.Footer />
      </Modal>
    </>
  );
};

export default NcDmvDrivingRecordModal;

NcDmvDrivingRecordModal.propTypes = {
  selectedDrivingRecord: PropTypes.instanceOf(Object).isRequired,
};
